export default __webpack_public_path__ + "static/media/download-icon-green.a8c4f58b.svg";